import { Slide } from '@mui/material';
import React from 'react';

import { BottomSheetProps } from './BottomSheet.props';
import {
  DragHandle,
  Overlay,
  SheetContainer,
  SheetContent,
  SheetFooter,
  SheetHeader,
  SheetSubtitle,
  SheetTitle,
} from './BottomSheet.styles';

export const BottomSheet: React.FC<BottomSheetProps> = ({
  open,
  onClose,
  height = 'medium',
  title,
  subtitle,
  footer,
  children,
}) => {
  if (!open) return null;

  return (
    <>
      <Overlay onClick={onClose} />
      <Slide direction="up" in={open} mountOnEnter unmountOnExit>
        <SheetContainer sheetHeight={height}>
          <DragHandle />
          {title && (
            <SheetHeader>
              <SheetTitle>{title}</SheetTitle>
              {subtitle && <SheetSubtitle>{subtitle}</SheetSubtitle>}
            </SheetHeader>
          )}
          <SheetContent>{children}</SheetContent>
          {footer && <SheetFooter>{footer}</SheetFooter>}
        </SheetContainer>
      </Slide>
    </>
  );
};
